module.exports = __webpack_public_path__ + "img/sellout.2c1fd24b.png";